module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":{"edit":"修改评论","delete":"删除评论"},"password":{"placeholder":"请输入写评论时设定的密码。","invalid":"密码不正确。"},"submit":{"edit":"修改评论","delete":"删除评论"}}}')
  delete Component.options._Ctor
}
